// 주문당 허용 입금액 = { total, total + 실배송비 }.
// ⚠ effectiveShipping 로직은 src/hooks/usePurchaseState.ts calculatedShippingFee 및
//    Deno matcher.ts 와 동일하게 유지.
export interface ShippingConfig {
  shippingFee: number | null;
  freeThreshold: number | null;
  jejuFreeShippingFee: number | null;
  shippingFeePresets: number[];
}

export function computeAcceptableAmounts(
  totalPrice: number,
  shippingFeeOverride: number | null,
  config: ShippingConfig,
): number[] {
  const ship = effectiveShipping(totalPrice, shippingFeeOverride, config);
  return ship === 0 ? [totalPrice] : [totalPrice, totalPrice + ship];
}

function effectiveShipping(totalPrice: number, override: number | null, config: ShippingConfig): number {
  if (override === 0) return 0;
  const thresholdMet = config.freeThreshold != null && config.freeThreshold > 0 && totalPrice >= config.freeThreshold;
  if (override != null && override > 0) {
    // 프리셋 의미론 분리(PR3): 등록된 '다른 배송비'는 제주/도서산간 해석이 아니다 —
    // 기준 도달 여부와 무관하게 지정 금액 유지. 판별은 토글 표시 우선순위(presets>jeju)와 동일 규칙.
    if (config.shippingFeePresets.includes(override)) return override;
    if (thresholdMet) return (config.jejuFreeShippingFee ?? 0) > 0 ? (config.jejuFreeShippingFee as number) : 0;
    return override;
  }
  return thresholdMet ? 0 : (config.shippingFee ?? 0);
}

// 완납 임계값 = 상품비 + 실효배송비 (스펙 D2). 무료배송이면 상품비.
// ⚠ 부분 입금 주문의 expectedAmounts는 [잔액]으로 재정의되므로 max(expectedAmounts)로 얻으면 안 됨.
export function paidThreshold(
  totalPrice: number,
  shippingFeeOverride: number | null,
  config: ShippingConfig,
): number {
  return Math.max(...computeAcceptableAmounts(totalPrice, shippingFeeOverride, config));
}

// 배송설정 지문 (스펙 2026-07-24 §3.3). SQL public.shipping_config_fingerprint와 정규화 규약 동일:
// 정수 반올림 문자열(null=''), '|' 구분, 프리셋 오름차순 ',' join. 서버-클라 불일치 = stale(설정 변경) 신호.
export function shippingConfigFingerprint(config: ShippingConfig): string {
  const n = (v: number | null) => (v == null ? '' : String(Math.round(v)));
  const presets = [...config.shippingFeePresets].map((v) => Math.round(v)).sort((a, b) => a - b);
  return [n(config.shippingFee), n(config.freeThreshold), n(config.jejuFreeShippingFee), presets.join(',')].join('|');
}
